{
    "CAT-ROE-Quick-Search-Fields": [
        {
            "label": "Event Type", "columnname": "type", "placeholder": "Event Type",
            "width": "", "datatype": "Array", "isLarge": false, "preserveUserOptedValues": true
        },
        {
            "label": "Symbol", "columnname": "symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Order ID", "columnname": "orderID", "placeholder": "Order ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Destination", "columnname": "destination", "placeholder": "Destination",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Firm Designated ID", "columnname": "firmDesignatedID", "placeholder": "Firm Designated ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "GroupName", "columnname": "groupName", "placeholder": "GroupName",
            "width": "", "datatype": "String", "isLarge": false
        }
    ],
    "CAT-ROE-Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Type",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Firm ROEID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Date",
            "db_columnname": "reportDate",
            "datatype": "date",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Timestamp",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order ID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "order Date",
            "db_columnname": "orderKeyDate",
            "datatype": "String",
            "mappingkey": "orderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "side",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "Int",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order Type",
            "db_columnname": "orderType",
            "datatype": "String",
            "mappingkey": "orderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TimeInForce",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Routed Order ID",
            "db_columnname": "routedOrderID",
            "datatype": "String",
            "mappingkey": "routedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination Type",
            "db_columnname": "destinationType",
            "datatype": "String",
            "mappingkey": "destinationType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Route Rejected Flag",
            "db_columnname": "routeRejectedFlag",
            "datatype": "Boolean",
            "mappingkey": "routeRejectedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "# of Legs",
            "db_columnname": "numberOfLegs",
            "datatype": "Float",
            "mappingkey": "numberOfLegs",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Firm Designated ID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sender IMID",
            "db_columnname": "senderIMID",
            "datatype": "String",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order ID",
            "db_columnname": "parentOrderID",
            "datatype": "String",
            "mappingkey": "parentOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "parent Order Date",
            "db_columnname": "parentOrderKeyDate",
            "datatype": "String",
            "mappingkey": "parentOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Receiver IMID",
            "db_columnname": "receiverIMID",
            "datatype": "String",
            "mappingkey": "receiverIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Routing Origin",
            "db_columnname": "routingOrigin",
            "datatype": "String",
            "mappingkey": "routingOrigin",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Receiving DeskType",
            "db_columnname": "receivingDeskType",
            "datatype": "String",
            "mappingkey": "receivingDeskType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LeavesQty",
            "db_columnname": "leavesQty",
            "datatype": "int",
            "mappingkey": "leavesQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CancelQty",
            "db_columnname": "cancelQty",
            "datatype": "int",
            "mappingkey": "cancelQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Prior Order ID",
            "db_columnname": "priorOrderID",
            "datatype": "String",
            "mappingkey": "priorOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Prior Order Date",
            "db_columnname": "priorOrderDate",
            "datatype": "String",
            "mappingkey": "priorOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Allocation ID",
            "db_columnname": "allocationID",
            "datatype": "String",
            "mappingkey": "allocationID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Manual Flag",
            "db_columnname": "manualFlag",
            "datatype": "Boolean",
            "mappingkey": "manualFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Manual Order ID",
            "db_columnname": "manualOrderID",
            "datatype": "String",
            "mappingkey": "manualOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Manual OrderKeyDate",
            "db_columnname": "manualOrderKeyDate",
            "datatype": "String",
            "mappingkey": "manualOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ISOInd",
            "db_columnname": "isoInd",
            "datatype": "String",
            "mappingkey": "isoInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "representativeInd",
            "db_columnname": "representativeInd",
            "datatype": "String",
            "mappingkey": "representativeInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Session",
            "db_columnname": "session",
            "datatype": "String",
            "mappingkey": "session",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "solicitationFlag",
            "db_columnname": "solicitationFlag",
            "datatype": "Boolean",
            "mappingkey": "solicitationFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Routed QuoteID",
            "db_columnname": "routedQuoteID",
            "datatype": "String",
            "mappingkey": "routedQuoteID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BidPrice",
            "db_columnname": "bidPrice",
            "datatype": "float",
            "mappingkey": "bidPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BidQty",
            "db_columnname": "bidQty",
            "datatype": "int",
            "mappingkey": "bidQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AskPrice",
            "db_columnname": "askPrice",
            "datatype": "float",
            "mappingkey": "askPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AskQty",
            "db_columnname": "askQty",
            "datatype": "float",
            "mappingkey": "askQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradeID",
            "db_columnname": "tradeID",
            "datatype": "String",
            "mappingkey": "tradeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "sideDetailsInd",
            "db_columnname": "sideDetailsInd",
            "datatype": "String",
            "mappingkey": "sideDetailsInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Buy Details",
            "db_columnname": "buyDetails",
            "datatype": "String",
            "mappingkey": "buyDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sell Details",
            "db_columnname": "sellDetails",
            "datatype": "String",
            "mappingkey": "sellDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Reporting Exception Code",
            "db_columnname": "reportingExceptionCode",
            "datatype": "String",
            "mappingkey": "reportingExceptionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side IMID",
            "db_columnname": "sideIMID",
            "datatype": "String",
            "mappingkey": "sideIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Capacity",
            "db_columnname": "capacity",
            "datatype": "String",
            "mappingkey": "capacity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TapeTradeID",
            "db_columnname": "tapeTradeID",
            "datatype": "String",
            "mappingkey": "tapeTradeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "MarketCenterID",
            "db_columnname": "marketCenterID",
            "datatype": "String",
            "mappingkey": "marketCenterID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Fulfillment ID",
            "db_columnname": "fulfillmentID",
            "datatype": "String",
            "mappingkey": "fulfillmentID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Client Details",
            "db_columnname": "clientDetails",
            "datatype": "String",
            "mappingkey": "clientDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Firm Details",
            "db_columnname": "firmDetails",
            "datatype": "String",
            "mappingkey": "firmDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Prior Fulfillment Date",
            "db_columnname": "priorFulfillmentDate",
            "datatype": "String",
            "mappingkey": "priorFulfillmentDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Prior Fulfillment ID",
            "db_columnname": "priorFulfillmentID",
            "datatype": "String",
            "mappingkey": "priorFulfillmentID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Fulfillment Link Type",
            "db_columnname": "fulfillmentLinkType",
            "datatype": "String",
            "mappingkey": "fulfillmentLinkType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },{
            "display": "true",
            "ui_columnname": "Handling Instructions",
            "db_columnname": "handlingInstructions",
            "datatype": "String",
            "mappingkey": "handlingInstructions",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AccountHolderType",
            "db_columnname": "accountHolderType",
            "datatype": "String",
            "mappingkey": "accountHolderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Department type",
            "db_columnname": "deptType",
            "datatype": "String",
            "mappingkey": "deptType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Affiliate Flag",
            "db_columnname": "affiliateFlag",
            "datatype": "Boolean",
            "mappingkey": "affiliateFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "MultiLegInd",
            "db_columnname": "multiLegInd",
            "datatype": "Boolean",
            "mappingkey": "multiLegInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OpenCloseIndicator",
            "db_columnname": "openCloseIndicator",
            "datatype": "String",
            "mappingkey": "openCloseIndicator",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "PairedOrderID",
            "db_columnname": "pairedOrderID",
            "datatype": "String",
            "mappingkey": "pairedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "netPrice",
            "db_columnname": "netPrice",
            "datatype": "Float",
            "mappingkey": "netPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "infoBarrierID",
            "db_columnname": "infoBarrierID",
            "datatype": "String",
            "mappingkey": "infoBarrierID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quoteKeyDate",
            "db_columnname": "quoteKeyDate",
            "datatype": "String",
            "mappingkey": "quoteKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quoteID",
            "db_columnname": "quoteID",
            "datatype": "String",
            "mappingkey": "quoteID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "electronicTimestamp",
            "db_columnname": "electronicTimestamp",
            "datatype": "String",
            "mappingkey": "electronicTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "requestTimestamp",
            "db_columnname": "requestTimestamp",
            "datatype": "String",
            "mappingkey": "requestTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trading Session",
            "db_columnname": "tradingSession",
            "datatype": "String",
            "mappingkey": "tradingSession",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Aggregated Orders",
            "db_columnname": "aggregatedOrders",
            "datatype": "String",
            "mappingkey": "aggregatedOrders",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "buyOrderID",
            "db_columnname": "buyOrderID",
            "datatype": "String",
            "mappingkey": "buyOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "sellOrderID",
            "db_columnname": "sellOrderID",
            "datatype": "String",
            "mappingkey": "sellOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "clientOrderID",
            "db_columnname": "clientOrderID",
            "datatype": "String",
            "mappingkey": "clientOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "firmOrderID",
            "db_columnname": "firmOrderID",
            "datatype": "String",
            "mappingkey": "firmOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Leg Details",
            "db_columnname": "legDetails",
            "datatype": "String",
            "mappingkey": "legDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Action Type",
            "db_columnname": "actionType",
            "datatype": "String",
            "mappingkey": "actionType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Error Code List",
            "db_columnname": "errorCodeList",
            "datatype": "String",
            "mappingkey": "errorCodeList",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Allocation Key Date",
            "db_columnname": "allocationKeyDate",
            "datatype": "String",
            "mappingkey": "allocationKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Allocation Type",
            "db_columnname": "allocationType",
            "datatype": "String",
            "mappingkey": "allocationType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Cancel Flag",
            "db_columnname": "cancelFlag",
            "datatype": "Boolean",
            "mappingkey": "cancelFlag",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Correspondent CRD",
            "db_columnname": "correspondentCRD",
            "datatype": "String",
            "mappingkey": "correspondentCRD",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Clearing Firm",
            "db_columnname": "clearingFirm",
            "datatype": "String",
            "mappingkey": "clearingFirm",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustDspIntrFlag",
            "db_columnname": "custDspIntrFlag",
            "datatype": "Boolean",
            "mappingkey": "custDspIntrFlag",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Customer Type",
            "db_columnname": "custType",
            "datatype": "String",
            "mappingkey": "custType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Fill Key Date",
            "db_columnname": "fillKeyDate",
            "datatype": "String",
            "mappingkey": "fillKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Initiator",
            "db_columnname": "initiator",
            "datatype": "String",
            "mappingkey": "initiator",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "New Order FDID",
            "db_columnname": "NewOrderFDID",
            "datatype": "String",
            "mappingkey": "NewOrderFDID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sender Type",
            "db_columnname": "senderType",
            "datatype": "String",
            "mappingkey": "senderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Settlement Date",
            "db_columnname": "settlementDate",
            "datatype": "String",
            "mappingkey": "settlementDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Date",
            "db_columnname": "tradeDate",
            "datatype": "String",
            "mappingkey": "tradeDate",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Order Key Date",
            "db_columnname": "tradeKeyDate",
            "datatype": "String",
            "mappingkey": "tradeKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BFMMFlag",
            "db_columnname": "BFMMFlag",
            "datatype": "Boolean",
            "mappingkey": "BFMMFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },{
            "display": "true",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Negotiated Trade Flag",
            "db_columnname": "NegotiatedTradeFlag",
            "datatype": "Boolean",
            "mappingkey": "negotiatedTradeFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Event Timestamp",
            "db_columnname": "EventTimestamp",
            "datatype": "String",
            "mappingkey": "EventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "excludeFromExport": "true",
            "field_info": "Please preserve (JSON Object Keys -> display | ui_columnname | db_columnname | mappingKey | excludeFromExport) this field forever as it is because EventTimeStamp field has been used for Default Date Filter in CAT-ROE-Viewer Screen so we need to add one more invisible EventTimeStamp Field for User Extended Search"
        }
    ]
}